var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":"Chọn nhóm để đồng bộ"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","options":[
				{ text: 'Xóa các nhóm hàng hiện có trên Website', value: 1 }
			]},model:{value:(_vm.configCategory),callback:function ($$v) {_vm.configCategory=$$v},expression:"configCategory"}}),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"stacked":"","options":[
				{
					text:
						'Thêm mới nhóm hàng trên KiotViet chưa tồn tại trên Website',
					value: 2
				}
			]},on:{"change":function($event){return _vm.changeConfig($event)}},model:{value:(_vm.configCategory),callback:function ($$v) {_vm.configCategory=$$v},expression:"configCategory"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-789bd02e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/category/CategoryHeader.vue
// module id = null
// module chunks = 